var map = {
	"./banner1.png": 220,
	"./banner2.png": 221,
	"./banner3.png": 222
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 255;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner ^\.\/banner.*\.png$
// module id = 255
// module chunks = 1